import { composeIO } from 'react-compose-io'
import { pedidosIO } from './Pedidos.IO'
import { PedidosView } from './Pedidos.View'

export const Pedidos = composeIO(PedidosView, pedidosIO)
